import { z } from 'zod';

export const SessionSchema = z.object({
  startTime: z.string(),
  duration: z.number(),
  supportedParticipantsCount: z.number(),
  priceTiers: z.array(
    z.object({
      id: z.string().uuid(),
      name: z.string(),
      price: z.number(),
    }),
  ),
  availableQuantityPerTier: z.record(z.number()).optional(),
});
export type Session = z.infer<typeof SessionSchema>;

export const FirstAvailableDateSchema = z.object({
  scheduledDate: z.string(),
  sessions: z.array(SessionSchema),
});
export type FirstAvailableDate = z.infer<typeof FirstAvailableDateSchema>;
